import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const BodyRepairShops = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default BodyRepairShops;
